"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var category_serializer_1 = require("../serialization/category.serializer");
var field_serializer_1 = require("../serialization/field.serializer");
var group_serializer_1 = require("../serialization/group.serializer");
var KbService = /** @class */ (function () {
    function KbService(http, store) {
        this.http = http;
        this.store = store;
        this.$kbUrl = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.map(function (properties) { return lodash_1.get(properties, 'kb-service-url'); }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for kb-service-url was not found')));
    }
    // region categories
    KbService.prototype.loadCategories = function (prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "categories")
                .pipe(operators_1.map(category_serializer_1.deserializeMetaCategories));
        }), operators_1.switchMap(function (categories) {
            if (categories.isEmpty()) {
                return of_1.of([]);
            }
            return zip_1.zip.apply(void 0, categories
                .map(function (category) { return _this.correctNameOfEntity(category); })
                .toArray());
        }), operators_1.map(function (categories) { return immutable_1.List(categories); }));
    };
    KbService.prototype.loadCategory = function (categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "categories/" + categoryName)
                .pipe(operators_1.map(category_serializer_1.createMetaCategory));
        }), operators_1.switchMap(function (category) {
            return _this.correctNameOfEntity(category);
        }));
    };
    KbService.prototype.createCategory = function (category, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "categories?updateDbStructure=true", category);
        }), operators_1.map(category_serializer_1.createMetaCategory));
    };
    KbService.prototype.updateCategory = function (category, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.patch(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "categories/" + category.systemName + "?updateDbStructure=true", category);
        }), operators_1.map(category_serializer_1.createMetaCategory));
    };
    KbService.prototype.deleteCategory = function (category, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.delete(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "categories/" + category.metaCategoryId.systemName + "?updateDbStructure=true");
        }), operators_1.map(function () { return category; }));
    };
    KbService.prototype.loadHierarchicalCategories = function (prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "hierarchicalcategories")
                .pipe(operators_1.map(function (fieldDtos) {
                return immutable_1.List(fieldDtos);
            }));
        }));
    };
    // endregion
    // region fields
    KbService.prototype.updateFields = function (categoryName, metaFields, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.patch(url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/fields?updateDbStructure=true", metaFields
                .toSeq()
                .groupBy(function (metaField) {
                if (skynet_store_utilities_1.notNil(metaField.systemName)) {
                    return metaField.systemName;
                }
                else {
                    throw new TypeError('trying to save meta-field without system name');
                }
            })
                .map(function (value) { return value.get(0); })
                .toJS());
        }), operators_1.map(function (metaFieldDtos) { return immutable_1.List(metaFieldDtos.map(field_serializer_1.createMetaField)); }));
    };
    KbService.prototype.updateField = function (categoryName, metaField, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.patch(url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/fields?updateDbStructure=true", (_a = {},
                _a[metaField.systemName] = [metaField],
                _a));
            var _a;
        }), operators_1.map(function (_a) {
            var fieldDto = _a[0];
            return field_serializer_1.createMetaField(fieldDto);
        }));
    };
    KbService.prototype.deleteField = function (metaField, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.request('DELETE', url + "/" + _this.urlCorrectionOnPrefix(prefix) + metaField.metaFieldId.metaCategoryId.systemName + "/fields?updateDbStructure=true", {
                body: [metaField.metaFieldId.systemName],
            });
        }), operators_1.map(function () { return metaField; }));
    };
    KbService.prototype.loadFields = function (categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "fields/" + categoryName)
                .pipe(operators_1.map(field_serializer_1.deserializeMetaFields));
        }), operators_1.switchMap(function (fields) {
            return zip_1.zip.apply(void 0, fields
                .map(function (category) { return _this.correctNameOfEntity(category); })
                .toArray());
        }), operators_1.map(function (fields) { return immutable_1.List(fields); }));
    };
    KbService.prototype.loadMainEntityFieldNames = function (categoryName, mainEntityFieldName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "mainentityfields/" + categoryName + "/" + mainEntityFieldName)
                .pipe(operators_1.map(function (fieldDtos) {
                return immutable_1.Set(fieldDtos.map(function (field) { return field.metaFieldId.systemName; }));
            }));
        }));
    };
    KbService.prototype.loadField = function (categoryName, fieldName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "fields/" + categoryName + "/" + fieldName)
                .pipe(operators_1.map(field_serializer_1.createMetaField));
        }), operators_1.switchMap(function (field) { return _this.correctNameOfEntity(field); }));
    };
    KbService.prototype.createField = function (categoryName, field, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/fields?updateDbStructure=true", [field]);
        }), operators_1.map(function (_a) {
            var metaFieldDto = _a[0];
            return field_serializer_1.createMetaField(metaFieldDto);
        }));
    };
    // endregion
    // region groups
    KbService.prototype.loadGroups = function (categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http
                .get(url + "/" + _this.urlCorrectionOnPrefix(prefix) + "groups/" + categoryName)
                .pipe(operators_1.map(function (values) { return group_serializer_1.deserializeGroups(values); }));
        }), operators_1.switchMap(function (fields) {
            return zip_1.zip.apply(void 0, fields
                .map(function (category) { return _this.correctNameOfEntity(category); })
                .toArray());
        }), operators_1.map(function (fields) { return immutable_1.List(fields); }));
    };
    KbService.prototype.createGroup = function (group, categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/groups", group);
        }), operators_1.map(group_serializer_1.createGroup));
    };
    KbService.prototype.updateGroups = function (groups, categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.patch(url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/groups", groups
                .groupBy(function (g) { return g.systemName; })
                .map(function (value) { return value.get(0); })
                .toJS());
        }), operators_1.map(function (resp) { return immutable_1.List(resp.map(group_serializer_1.createGroup)); }));
    };
    KbService.prototype.deleteGroup = function (group, categoryName, prefix) {
        var _this = this;
        return this.$kbUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.request('DELETE', url + "/" + _this.urlCorrectionOnPrefix(prefix) + categoryName + "/groups", {
                body: [group],
            });
        }), operators_1.map(function () { return group; }));
    };
    // endregion
    KbService.prototype.convertMessageToMultilingual = function (name) {
        var _this = this;
        return skynet_store_languages_api_1.languageStoreManager.selectAll(this.store).pipe(operators_1.distinctUntilChanged(function (a, b) { return a.equals(b); }), operators_1.map(function (languages) {
            return languages
                .toSeq()
                .map(function (language) { return language.getId(); })
                .map(function (languageId) { return skynet_store_messages_api_1.MessageKeyFactory({ name: name, languageId: languageId }); });
        }), operators_1.switchMap(function (keys) {
            return zip_1.zip.apply(void 0, keys
                .map(function (key) {
                return skynet_store_messages_api_1.messageStoreManager
                    .selectOne(_this.store, key)
                    .pipe(operators_1.filter(skynet_store_utilities_1.notNil));
            })
                .toList()
                .toArray());
        }), operators_1.map(function (messages) {
            return messages
                .reduce(function (builder, message) {
                return builder.withValueForLanguage(message.key.languageId, message.value);
            }, idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder())
                .build();
        }));
    };
    KbService.prototype.correctNameOfEntity = function (entityWithName) {
        if (skynet_store_utilities_1.isEmptyMultilingual(entityWithName.displayNameMultilingual) &&
            !lodash_1.isEmpty(entityWithName.displayName)) {
            return this.convertMessageToMultilingual(entityWithName.displayName).pipe(operators_1.map(function (name) {
                entityWithName.displayNameMultilingual = name;
                return entityWithName;
            }));
        }
        else if (lodash_1.isNil(entityWithName.displayNameMultilingual) &&
            lodash_1.isEmpty(entityWithName.displayName)) {
            entityWithName.displayNameMultilingual = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().build();
            return of_1.of(entityWithName);
        }
        else {
            return of_1.of(entityWithName);
        }
    };
    KbService.prototype.urlCorrectionOnPrefix = function (prefix) {
        return lodash_1.isNil(prefix) || prefix === skynet_store_kb_api_1.defaultKbKey ? '' : prefix + '/';
    };
    KbService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            store_1.Store])
    ], KbService);
    return KbService;
}());
exports.KbService = KbService;
//# sourceMappingURL=kb.service.js.map